import { render, staticRenderFns } from "./Artplayer.vue?vue&type=template&id=9c44a32c"
import script from "./Artplayer.vue?vue&type=script&lang=js"
export * from "./Artplayer.vue?vue&type=script&lang=js"
import style0 from "./Artplayer.vue?vue&type=style&index=0&id=9c44a32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports